// extracted by mini-css-extract-plugin
module.exports = {"round_button":"dece2e673c--round_button--1UdnL","delete_button":"dece2e673c--delete_button--2a1A9"};